import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { CategoryDetailsFragment, OptionGroupDetailsFragment } from '../utils/fragments'
import { Category, OptionGroup } from '../utils/category'

const MENU_BY_VERSION_QUERY = gql`
	query MenuByVersion($restaurantId: ID!, $menuVersion: Int!) {
		menuByVersion(restaurantId: $restaurantId, menuVersion: $menuVersion) {
			categories {
				...CategoryDetailsFragment
			}
			optionGroups {
				...OptionGroupDetailsFragment
			}
			totalProducts
			totalOptions
		}
	}
	${CategoryDetailsFragment}
	${OptionGroupDetailsFragment}
`

export const useMenuByVersion = (args: {
	restaurantId: string | null
	menuVersion: number | null
}): {
	categories: Category[]
	optionGroups: OptionGroup[]
	totalProducts: number
	totalOptions: number
	loading: boolean
} => {
	const { data } = useQuery(MENU_BY_VERSION_QUERY, {
		variables: { restaurantId: args.restaurantId, menuVersion: args.menuVersion },
		skip: args.restaurantId === null || args.menuVersion === null,
		fetchPolicy: 'cache-and-network',
	})
	const menu = data?.menuByVersion as
		| {
				categories: Category[]
				optionGroups: OptionGroup[]
				totalProducts: number
				totalOptions: number
		  }
		| undefined
	return React.useMemo(
		() => ({
			categories: menu?.categories ?? [],
			optionGroups: menu?.optionGroups ?? [],
			totalProducts: menu?.totalProducts ?? 0,
			totalOptions: menu?.totalOptions ?? 0,
			loading: data === undefined,
		}),
		[data, menu]
	)
}
